module.exports = "/static/media/OrderPlaced.4a7b820c.jpg";